const MobileHyfye = () => { 
  return (
    <section id="mobileapp" className="bg_light_dark" data-z-index="1" data-parallax="scroll" data-image-src="assets/images/mobilephone.jpg">
      <div className="container">
        <div className="row align-items-center">

          {/* Left Side - Text */}
          <div className="col-lg-7 col-md-12 col-sm-12">
            <div className="title_default_light title_border text_md_center">
              <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.2s">Hyfye Mobile & Desktop Experience</h4>
              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
                Get ready to experience the world's first universal tipping ecosystem — right from your phone or computer. 
                The Hyfye App will allow you to earn, tip, and transact effortlessly, bringing a borderless gratitude economy to your fingertips.
              </p>
              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.6s">
                From tipping your favorite creators, supporting service providers, to buying and selling — Hyfye empowers everyday actions to have real economic value in both the digital and real world.
              </p>
              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.8s">
                Launching soon on iOS, Android, and Desktop. Join the movement and be part of the next evolution in digital engagement!
              </p>
            </div>

            {/* Buttons */}
            <div className="btn_group text_md_center animation" data-animation="fadeInUp" data-animation-delay="1s"> 
              <a href="#" className="btn btn-default disabled"><em className="ion-social-android"></em>Coming Soon</a> 
              <a href="#" className="btn btn-default disabled"><em className="ion-social-apple"></em>Coming Soon</a> 
            </div>
          </div>

          {/* Right Side - Image */}
          <div className="col-lg-5 col-md-12 col-sm-12">
            <div className="res_md_mt_50 res_sm_mt_30 text-center animation" data-animation="fadeInRight" data-animation-delay="0.2s"> 
              <img src="assets/images/mobile_app3.png" alt="Hyfye App Coming Soon" /> 
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}

export default MobileHyfye;
